module.exports = __webpack_public_path__ + "img/import-1.6a01dd8e.svg";